import { gql } from '@apollo/client';

export const CREATE_REPORT = gql`
  mutation createUpdateReportProfile($save: ReportProfileInput) {
    createUpdateReportProfile(input: $save) {
      id
    }
  } 
`;
